import ServiceDetail from "@/components/ServiceDetail";

const description = [
  "Genspire's Recruitment Process Outsourcing (RPO) service enables organizations to outsource part or all of their recruitment activities to a dedicated recruitment partner. We work as an extension of your internal team and align our recruitment approach with your organization's hiring requirements, processes and objectives.",
  "Organizations often face challenges when managing multiple vacancies, high-volume recruitment, specialized hiring or continuous talent requirements while also running their regular business operations. An RPO model provides additional recruitment capacity and structured support — without requiring your team to manage every stage of the hiring process internally.",
  "Depending on the requirement, Genspire can support specific stages of recruitment or manage a broader recruitment lifecycle. This may include understanding hiring requirements, talent sourcing, candidate screening, shortlisting, interview coordination, candidate communication, recruitment tracking and ongoing hiring support.",
  "We take a consultative approach: understanding your existing recruitment process and determining where our support can add the most value. Our RPO solutions can be structured around your needs — whether that means support with selected roles, a specific recruitment project or ongoing recruitment activities.",
  "By working alongside your internal HR and talent teams, Genspire aims to improve recruitment efficiency, provide additional hiring capacity and create a more organized recruitment experience — allowing your internal teams to focus on strategic priorities while we support the operational aspects of talent acquisition.",
];

const steps = [
  { title: "Discover", text: "A consultative review of your existing recruitment process, hiring volumes, and where support adds the most value." },
  { title: "Design", text: "A structured RPO model shaped around your needs — selected roles, a specific project, or ongoing recruitment activity." },
  { title: "Deliver", text: "We run the agreed recruitment lifecycle: sourcing, screening, shortlisting, coordination, and communication." },
  { title: "Refine", text: "Ongoing alignment, tracking, and reporting so recruitment stays efficient as your requirements evolve." },
];

const benefits = [
  "Additional recruitment capacity without expanding your internal team",
  "A more organized, consistent recruitment experience across roles",
  "Support for high-volume, specialized, or continuous hiring requirements",
  "A consultative model aligned with your existing processes and objectives",
  "Internal HR and talent teams stay focused on strategic priorities",
  "Flexible scope — selected roles, a recruitment project, or the full lifecycle",
];

export default function Rpo() {
  return (
    <ServiceDetail
      headlineTop="Recruitment Process"
      headlineAccent="Outsourcing."
      tagline="Extending your recruitment capabilities with dedicated support."
      description={description}
      steps={steps}
      benefits={benefits}
      benefitsHeading="Why Organizations Choose RPO"
      submitLabel="Talk to Our Team"
      pageTestId="rpo-page"
      ctaTitle="Talk to Our Team"
      ctaSub="Tell us about your hiring landscape — we'll design the right support model around it."
    />
  );
}
